// Mock data for the entire application

export const PHONE = '05322114690';
export const PHONE_DISPLAY = '0532 211 46 90';
export const WHATSAPP_URL = `https://wa.me/90${PHONE.substring(1)}`;

export const SERVICES = [
  {
    id: 'dogalgaz-tesisati',
    title: 'Doğal Gaz Tesisatı',
    shortTitle: 'Doğal Gaz Tesisatı',
    icon: '🔥',
    color: '#ff6b35',
    description: 'Lisanslı teknisyenlerimiz ile ev, daire ve iş yerlerinizde güvenli doğal gaz tesisat kurulumu, tamirat ve yenileme işlemleri yapıyoruz.',
    priceRange: '₺2.500 - ₺15.000',
    duration: '1-3 gün',
    features: ['Lisanslı montaj', 'IGGD onaylı', 'Kaçak testi', 'Garanti belgeli'],
    category: 'montaj',
    popular: true,
  },
  {
    id: 'su-tesisati',
    title: 'Su Tesisatı',
    shortTitle: 'Su Tesisatı',
    icon: '💧',
    color: '#00b4cc',
    description: 'Sıhhi tesisat kurulumu, su kaçağı tamiri, boru yenileme ve tüm su tesisatı işlemlerini profesyonel ekibimizle çözüyoruz.',
    priceRange: '₺500 - ₺20.000',
    duration: '1 saat - 5 gün',
    features: ['PPR/PVC boru', 'Kaçak tespiti', 'Boru yenileme', 'Acil servis'],
    category: 'tesisat',
    popular: true,
  },
  {
    id: 'kalorifer-tesisati',
    title: 'Kalorifer Tesisatı',
    shortTitle: 'Kalorifer Tesisatı',
    icon: '♨️',
    color: '#ffc107',
    description: 'Kalorifer tesisat kurulumu, petek montajı, sistem yenileme ve bakım işlemlerini uzman ekibimizle gerçekleştiriyoruz.',
    priceRange: '₺1.500 - ₺30.000',
    duration: '1-7 gün',
    features: ['Petek montajı', 'Boru tesisatı', 'Sistem dengeleme', 'Garanti belgeli'],
    category: 'tesisat',
    popular: false,
  },
  {
    id: 'yerden-isitma',
    title: 'Yerden Isıtma',
    shortTitle: 'Yerden Isıtma',
    icon: '🌡️',
    color: '#ff4444',
    description: 'Hidronik ve elektrikli yerden ısıtma sistemlerinin kurulumu, bakımı ve tamirini profesyonel ekibimizle yapıyoruz.',
    priceRange: '₺5.000 - ₺50.000',
    duration: '3-14 gün',
    features: ['Hidronik sistem', 'Akıllı termostat', 'Enerji tasarrufu', 'Proje çizimi'],
    category: 'proje',
    popular: false,
  },
  {
    id: 'mobil-sistem',
    title: 'Mobil Sistem',
    shortTitle: 'Mobil Sistem',
    icon: '🚐',
    color: '#0d6aa8',
    description: 'Tüm ekipmanlarımızla sahaya gelen mobil servis ekibimiz, acil durumlarda 45 dakikada adresinizde hazır bulunur.',
    priceRange: '₺400 - ₺3.000',
    duration: '30 dk - 4 saat',
    features: ['Hızlı müdahale', '45 dk ulaşım', 'Tam donanımlı araç', 'Anında müdahale'],
    category: 'acil',
    popular: true,
  },
  {
    id: 'kombi-bakimi',
    title: 'Kombi Bakımı',
    shortTitle: 'Kombi Bakımı',
    icon: '⚙️',
    color: '#00c851',
    description: 'Tüm marka ve model kombilerin periyodik bakımı, arıza tespiti ve tamiri konusunda yetkili servis kalitesinde hizmet veriyoruz.',
    priceRange: '₺800 - ₺5.000',
    duration: '1-4 saat',
    features: ['Tüm markalar', 'Periyodik bakım', 'Arıza tespiti', 'Yedek parça'],
    category: 'bakim',
    popular: false,
  },
  {
    id: 'villa-daire-tesisati',
    title: 'Villa ve Daire Tesisatı',
    shortTitle: 'Villa & Daire Tesisatı',
    icon: '🏠',
    color: '#8b5cf6',
    description: 'Villa, daire ve konut projelerinde komple tesisat kurulumu; doğalgaz, su ve ısıtma sistemlerini anahtar teslim teslim ediyoruz.',
    priceRange: '₺15.000 - ₺100.000',
    duration: '5-30 gün',
    features: ['Anahtar teslim', 'Proje çizimi', 'Komple kurulum', '5 yıl garanti'],
    category: 'proje',
    popular: false,
  },
];

export const STATS = [
  { label: 'Müşteri Memnuniyeti', value: 100, prefix: '%', suffix: '', icon: '😊' },
  { label: 'Tamamlanan İş', value: 28000, suffix: '+', icon: '✅' },
  { label: 'Yıllık Deneyim', value: 18, suffix: '', icon: '🏆' },
  { label: 'Uzman Teknisyen', value: 45, suffix: '+', icon: '👷' },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Ahmet Yılmaz',
    role: 'Ev Sahibi',
    location: 'Kadıköy, Ankara',
    rating: 5,
    text: 'Yaklaşık 4 aydır mutfak tezgahı altında nem kokusu vardı, birçok ustaya baktırdık ama kimse bulamadı. Taşgın ekibi termal kamera ile geldi ve tam 18 dakikada duvardaki gizli kaçağı tespit etti. Duvarı delmeden, doğrudan kaçak noktasına ulaştılar. İşçilik son derece temizdi, ardında hiçbir pislik bırakmadılar. Bu işi gerçekten teknoloji ile yapan, sözünde duran bir firma. Kesinlikle herkese tavsiye ederim.',
    avatar: 'AY',
    service: 'Su Kaçağı Tespiti',
    date: '3 gün önce',
  },
  {
    id: 2,
    name: 'Fatma Kaya',
    role: 'Apartman Yöneticisi',
    location: 'Güzelkent, Ankara',
    rating: 5,
    text: '24 daireli binamızın tüm su ve ısıtma tesisatını Taşgın yeniledi. Proje öncesinde detaylı keşif gelip kat planına göre çizim hazırladılar. Çalışma boyunca sakinlere minimum rahatsızlık verdiler, sabah 8\'de başlayıp akşam 6\'ya kadar düzenli çalıştılar. Garanti belgesi ve bakım sözleşmesiyle teslim ettiler. Hem fiyat performans hem de işçilik açısından İstanbul\'da çalıştığımız en iyi firma bu oldu.',
    avatar: 'FK',
    service: 'Komple Tesisat Yenileme',
    date: '1 hafta önce',
  },
  {
    id: 3,
    name: 'Mehmet Demir',
    role: 'Restoran Sahibi',
    location: 'Altındağ, Ankara',
    rating: 5,
    text: 'Gece 02:15\'te ana gider borusunda tam tıkanıklık yaşadık. Mutfak ve tuvaletler kullanılamaz hale geldi, restoranı kapatmak zorunda kaldık. Taşgın\'ı aradım, telefonu ilk çalışta açtılar. 40 dakikada ekip kapıdaydı, yanlarında hydrojet sistemi vardı. Saat 04:00\'e kadar her şey çözüldü ve sabah normal çalışma saatinde açabildik. Bu konuda güvenebileceğiniz, gerçekten 7/24 olan tek firma bunlar.',
    avatar: 'MD',
    service: 'Acil Tıkanıklık Açma',
    date: '2 hafta önce',
  },
  {
    id: 4,
    name: 'Zeynep Arslan',
    role: 'İç Mimar',
    location: 'Çankaya, Ankara',
    rating: 5,
    text: 'Bir müşterimizin 180 m² dairesinin banyosunu ve mutfağını komple yeniledik. Tesisat kısmını Taşgın ile yürüttük. Hem zemin içi boru güzergahı planlaması hem de duvar içi tesisatı kusursuz uyguladılar. Yaptıkları her aşamayı fotoğraflayıp raporladılar, bu iç mimar olarak benim için çok kıymetli. Artık her projemde Taşgın ile çalışıyorum, müşterilerime de öncelikli olarak tavsiye ediyorum.',
    avatar: 'ZA',
    service: 'Banyo & Mutfak Tesisat',
    date: '3 hafta önce',
  },
  {
    id: 5,
    name: 'Hüseyin Kılıç',
    role: 'Bina Sahibi',
    location: 'Mamak, Ankara',
    rating: 5,
    text: 'Binamızda yıllardır çözülemeyen zemin altı su kaçağı sorunu vardı. Daha önce 3 farklı firma baktı, kimse bulamadı, üstüne üstlük gereksiz yerleri kırdılar. Taşgın akustik dedektör ve termal kamera ile geldi, 2 saatlik inceleme sonunda tam kaçak noktasını belirledi. Minimal müdahaleyle sorunu hallettiler, kırdıkları yerleri de eksiksiz onardılar. Gerçek anlamda teknolojik çalışan, işini bilen ustalar bunlar.',
    avatar: 'HK',
    service: 'Zemin Altı Kaçak Tespiti',
    date: '1 ay önce',
  },
  {
    id: 6,
    name: 'Elif Öztürk',
    role: 'Ev Hanımı',
    location: 'Etimesgut, Ankara',
    rating: 5,
    text: 'Banyo tadilatını yaptırdım, pisuvar ve duş kabini montajı ile yeni tesisat bağlantıları dahil her şeyi Taşgın halletti. Usta son derece kibar, temizine dikkat eden biriydi. İşi bitince her şeyi topladı, zemin ve duvarları sildi, banyoyu benden temiz bıraktı desem abartı olmaz. Fiyatı önceden net söyledi, işin sonunda fazladan hiçbir ücret çıkmadı. Bu güven çok önemli.',
    avatar: 'EÖ',
    service: 'Banyo Tesisat Montajı',
    date: '1 ay önce',
  },
  {
    id: 7,
    name: 'Mustafa Şahin',
    role: 'Site Yöneticisi',
    location: 'Sincan, Ankara',
    rating: 5,
    text: '120 daireli sitemizde kış ortasında ısıtma arızası çıktı. Gece saat 11\'de aradım, sabah 7\'de ekip kapıdaydı. Petek sisteminin ana dağıtım borusunda çatlak tespit ettiler ve 3 saat içinde çözüme kavuşturdular. Sakinlere 1 günden az süre ısıtmasız kaldılar. Acil durumlarda bu kadar hızlı ve organize çalışan başka bir firma görmedim.',
    avatar: 'MŞ',
    service: 'Acil Kalorifer Tamiri',
    date: '5 gün önce',
  },
  {
    id: 8,
    name: 'Seda Yıldırım',
    role: 'Kiracı',
    location: 'Keçiören, Ankara',
    rating: 5,
    text: 'Kiracı olarak yaşadığım dairede sürekli düşük su basıncı problemi vardı, ev sahibi "normal" diyordu. Taşgın\'a başvurdum, boru içi kamera ile incelediler; borularda ciddi kireç birikimi varmış. Hydrojet ile temizledikten sonra basınç ikiye katlandı. Hem hızlı hem de uygun fiyatlıydı. Raporlarını ev sahibine gösterdim, şikayetim belgelendi. Herkese tavsiye ederim.',
    avatar: 'SY',
    service: 'Boru Temizleme',
    date: '1 hafta önce',
  },
  {
    id: 9,
    name: 'Bülent Çelik',
    role: 'Otel Müdürü',
    location: 'Ulus, Ankara',
    rating: 5,
    text: '45 odalı otelimizin komple sıhhi tesisat revizyonunu Taşgın üstlendi. Misafir memnuniyetini etkilemeden, odalar boşaldıkça kat kat ilerlediler. Proje yönetimi mükemmeldi; her sabah o günün planını paylaştılar, her akşam tamamlanan işlerin fotoğraflı raporunu sundular. Teslimatta sıfır sorun, tüm odalar test edildi. Kurumsal iş yapan profesyonel bir ekip.',
    avatar: 'BÇ',
    service: 'Komple Tesisat Revizyonu',
    date: '2 hafta önce',
  },
  {
    id: 10,
    name: 'Arzu Kılınç',
    role: 'Eczane Sahibi',
    location: 'Yenimahalle, Ankara',
    rating: 5,
    text: 'Eczanemizin deposunda nemlenme ve rutubet sorunu vardı, ilaçlar risk altındaydı. Taşgın ekibi termal kamera ile taradı, duvar arkasındaki yoğuşma borusunu tespit etti. Hem tamir hem yalıtım işini aynı günde tamamladılar. O günden bu yana nem sorunu tamamen bitti. Hızlı, güvenilir ve sözünde duran bir ekip.',
    avatar: 'AK',
    service: 'Nem & Kaçak Tespiti',
    date: '3 hafta önce',
  },
  {
    id: 11,
    name: 'Tarık Bozkurt',
    role: 'Müteahhit',
    location: 'Pursaklar, Ankara',
    rating: 5,
    text: 'İnşaat projelerimizde alt yapı tesisatı için birçok firma ile çalıştım. Taşgın\'ı 2 yıl önce denedim, o günden beri değiştirmedim. Çizime birebir uyuyorlar, malzeme kalitesinden ödün vermiyorlar, proje bitmeden önce kapsamlı basınç testi yapıyorlar. Taşeron sıkıntısının had safhada olduğu bu sektörde böyle bir ekip bulmak gerçekten büyük şans.',
    avatar: 'TB',
    service: 'İnşaat Altyapı Tesisatı',
    date: '1 ay önce',
  },
  {
    id: 12,
    name: 'Gülşen Arslan',
    role: 'Ev Sahibi',
    location: 'Gölbaşı, Ankara',
    rating: 5,
    text: 'Villam için yerden ısıtma sistemi kurmak istiyordum ama hangi firmaya güveneceğimi bilemedim. Taşgın\'ın referanslarına baktım, teknik bilgilerini test ettim; her soruya net cevap verdiler. Kurulum boyunca her boruyu düzenli aralıklarla test ettiler. Sistemi açtığımda tüm odalar eşit ısındı. Üstelik enerji faturam bir önceki kışa göre %28 düştü.',
    avatar: 'GA',
    service: 'Yerden Isıtma Sistemi',
    date: '2 ay önce',
  },
];

export const TECHNOLOGIES = [
  {
    name: 'Termal Kamera',
    brand: 'FLIR E8-XT',
    description: 'Duvar ve zemin içindeki sıcaklık farklarını tespit ederek gizli su kaçaklarını milimetrik hassasiyetle bulur.',
    icon: '🔴',
    specs: ['320x240 px IR', '±2°C hassasiyet', '-20°C to 550°C aralık', 'WiFi veri aktarımı'],
  },
  {
    name: 'Boru İçi Robot Kamera',
    brand: 'Ridgid SeeSnake',
    description: '25mm\'ye kadar boru içinde hareket eden miniature robotik kamera sistemi. 4K görüntü kalitesi.',
    icon: '🤖',
    specs: ['4K görüntü', '60m kablo uzunluğu', 'LED aydınlatma', 'Kayıt özelliği'],
  },
  {
    name: 'Hydrojet Sistemi',
    brand: 'Kärcher HDS 13/20-4S',
    description: '200 bar basınç ile her türlü tıkanıklığı, yağ birikintisini ve kireç tabakasını temizler.',
    icon: '💧',
    specs: ['200 bar basınç', 'Sıcak su desteği', '20L/dk debi', 'Mobil sistem'],
  },
  {
    name: 'Akustik Kaçak Dedektörü',
    brand: 'Sewerin Aquaphon',
    description: 'Boru titreşimlerini analiz ederek zemin altındaki kaçak noktasını 30 cm hassasiyetle lokalize eder.',
    icon: '🎵',
    specs: ['±30cm hassasiyet', 'Gürültü filtresi', 'Dijital analiz', 'Bluetooth bağlantı'],
  },
];

export const TEAM_MEMBERS = [
  { name: 'Mustafa Taşgın', role: 'Kurucu & Baş Tesisat Uzmanı', exp: '18 yıl', avatar: 'MT', online: true },
  { name: 'Serkan Öztürk', role: 'Termal Görüntüleme Uzmanı', exp: '9 yıl', avatar: 'SÖ', online: true },
  { name: 'Kadir Çelik', role: 'Robotik Sistemler Teknisyeni', exp: '7 yıl', avatar: 'KÇ', online: false },
  { name: 'Barış Yıldız', role: 'Proje & Renovasyon Müdürü', exp: '12 yıl', avatar: 'BY', online: true },
];

export const BLOG_POSTS = [
  {
    id: 1,
    slug: 'su-kacagi-belirtileri',
    title: 'Su Kaçağının 7 Gizli Belirtisi – Evde Tespit Edin',
    excerpt: 'Su faturanız aniden arttı mı? Duvarlarda nem lekesi mi var? İşte evinizde gizli su kaçağı olduğuna işaret eden 7 kritik belirti.',
    category: 'İpuçları',
    readTime: '5 dk',
    date: '12 Mayıs 2026',
    image: 'su-kacagi',
    views: 4200,
  },
  {
    id: 2,
    slug: 'kisi-oncesi-tesisat-bakimi',
    title: 'Kış Öncesi Yapılması Gereken 10 Tesisat Bakımı',
    excerpt: 'Dondurucu soğuklar gelmeden önce borularınızı, peteğinizi ve su tesisatınızı hazırlamak için bu 10 adımı uygulayın.',
    category: 'Bakım',
    readTime: '7 dk',
    date: '28 Nisan 2026',
    image: 'bakim',
    views: 3100,
  },
  {
    id: 3,
    slug: 'ppr-boru-avantajlari',
    title: 'PPR Boru Nedir? Galvaniz Borulardan Farkı',
    excerpt: 'Modern PPR boru sistemi vs eski galvaniz borular. Hangi durumda hangisi tercih edilmeli? Uzman görüşü.',
    category: 'Teknik',
    readTime: '6 dk',
    date: '15 Nisan 2026',
    image: 'boru',
    views: 2800,
  },
];

export const AVAILABLE_HOURS = [
  '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00'
];

export const BUSY_DATES = [
  new Date(2026, 4, 16),
  new Date(2026, 4, 20),
  new Date(2026, 4, 23),
];

export const FAULT_TYPES = [
  { id: 'su-kacagi', label: 'Su Kaçağı', icon: '💧', priceMin: 800, priceMax: 2500, durationMin: 1, durationMax: 3 },
  { id: 'tikanikhlik', label: 'Tıkanıklık', icon: '🔄', priceMin: 500, priceMax: 3000, durationMin: 0.5, durationMax: 2 },
  { id: 'petek', label: 'Petek / Kalorifer', icon: '🔥', priceMin: 1200, priceMax: 4000, durationMin: 2, durationMax: 6 },
  { id: 'boru-patlamasi', label: 'Boru Patlaması', icon: '💥', priceMin: 1500, priceMax: 5000, durationMin: 2, durationMax: 8 },
  { id: 'tesisat-yenileme', label: 'Tesisat Yenileme', icon: '🔧', priceMin: 8000, priceMax: 45000, durationMin: 72, durationMax: 336 },
  { id: 'banyo', label: 'Banyo Tesisatı', icon: '🚿', priceMin: 2000, priceMax: 8000, durationMin: 4, durationMax: 16 },
  { id: 'dogalgaz', label: 'Doğalgaz / Kombi', icon: '⚡', priceMin: 2500, priceMax: 12000, durationMin: 4, durationMax: 48 },
  { id: 'diger', label: 'Diğer Arıza', icon: '❓', priceMin: 400, priceMax: 2000, durationMin: 1, durationMax: 4 },
];

export const ADMIN_MOCK_DATA = {
  monthlyRevenue: [
    { month: 'Oca', gelir: 48000, is: 42 },
    { month: 'Şub', gelir: 52000, is: 48 },
    { month: 'Mar', gelir: 61000, is: 55 },
    { month: 'Nis', gelir: 58000, is: 51 },
    { month: 'May', gelir: 74000, is: 68 },
    { month: 'Haz', gelir: 0, is: 0 },
  ],
  serviceDistribution: [
    { name: 'Su Kaçağı', value: 35, color: '#ff4444' },
    { name: 'Tıkanıklık', value: 28, color: '#ff6b35' },
    { name: 'Petek', value: 15, color: '#ffc107' },
    { name: 'Tesisat', value: 12, color: '#00b4cc' },
    { name: 'Diğer', value: 10, color: '#6b7e90' },
  ],
  recentJobs: [
    { id: 'TG-2026-0521', customer: 'Ayşe Demir', service: 'Su Kaçağı Tespiti', status: 'Tamamlandı', tech: 'Serkan Ö.', amount: 1800, date: '14 May', address: 'Kadıköy' },
    { id: 'TG-2026-0520', customer: 'Murat Çetin', service: 'Tıkanıklık Açma', status: 'Devam Ediyor', tech: 'Kadir Ç.', amount: 900, date: '14 May', address: 'Şişli' },
    { id: 'TG-2026-0519', customer: 'Elif Yıldız', service: 'Petek Temizleme', status: 'Usta Yolda', tech: 'Barış Y.', amount: 2400, date: '14 May', address: 'Beşiktaş' },
    { id: 'TG-2026-0518', customer: 'Osman Kılıç', service: 'Boru Patlaması', status: 'Tamamlandı', tech: 'Mustafa T.', amount: 3200, date: '13 May', address: 'Üsküdar' },
    { id: 'TG-2026-0517', customer: 'Hasan Öz', service: 'Doğalgaz Montaj', status: 'Tamamlandı', tech: 'Serkan Ö.', amount: 4500, date: '13 May', address: 'Fatih' },
  ],
};
